// project imports
import getColors from 'utils/getColors';

// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //

// Focus uses a crisp 2px border on the notchedOutline (the visible fieldset).
// We deliberately avoid a box-shadow ring on the root: the fieldset is offset
// ~5px upward for the floating-label notch, so a root ring renders misaligned.
function getColor({ variant, theme }) {
  const colors = getColors(theme, variant);
  const { light, main } = colors;

  return {
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: light },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: main, borderWidth: '2px' }
  };
}

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '10.5px 14px 10.5px 12px',
        },
        notchedOutline: {
          borderColor: '#E2E8F0',
          borderRadius: 8,
        },
        root: {
          borderRadius: 8,
          transition: 'border-color 0.2s, box-shadow 0.2s',
          ...getColor({ variant: 'primary', theme }),
          '&.Mui-error': { ...getColor({ variant: 'error', theme }) }
        },
        inputSizeSmall: { padding: '7.5px 8px 7.5px 12px' },
        inputMultiline: { padding: 0 },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme })
      }
    }
  };
}
